import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { JobsRoutingModule } from './jobs-routing.module';
import { JobComponent } from './job/job.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MatchHeightModule } from 'app/shared/directives/match-height.directive';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    JobComponent
  ],
  imports: [
    CommonModule,
    JobsRoutingModule,
    NgxChartsModule,
    NgbModule,
    MatchHeightModule,
    NgxSpinnerModule,
    NgSelectModule,
    FormsModule
  ]
})
export class JobsModule { }
